<div [@enterAnimation] [@leaveAnimation]>
    <div class="float-l relative">
        <div class="link-all-tenders"><button type="button" mat-mini-fab color="link" (click)="onCancel()"><mat-icon>arrow_back_ios</mat-icon></button></div>
    </div>
    <div>
        <h1 class="middle-blue top-title">רישום לקבלת עדכונים</h1>
    </div>
    <div class="tender-details">
        <div><label class="fs-15">שם מכרז: </label><b class="fs-20">{{tender.Title}}</b></div>
        <div><label class="fs-15">מספר מכרז: </label><b class="fs-20">{{tender.MolsaTenderNumber}}</b></div>
    </div>
    <form [formGroup]="regForm" #ngForm="ngForm">
        <div>
            <div class="row-items">
                <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                    <mat-label>שם הספק/חברה</mat-label>
                    <input type="text" placeholder="שם הספק/חברה" matInput formControlName="CompanyName" maxlength="50" required /> 
                </mat-form-field>
                <div></div>
            </div>
            <div class="row-items"> 
                <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                    <mat-label>מספר הספק/חברה</mat-label>
                    <input placeholder="ע.מ./ח.פ./ח.צ./ע.ר." matInput formControlName="CompanyNumber" maxlength="9" required /> 
                </mat-form-field>
                <div></div>
            </div>
            <div *ngIf="ngForm.submitted && regForm.controls.CompanyNumber.invalid" class="alert">
                <div *ngIf="regForm.controls.CompanyNumber.errors && regForm.controls.CompanyNumber.errors.tz">
                    {{regForm.controls.CompanyNumber.errors.tz}}
                </div>
            </div>
        </div>
        <div class="box">
            <h3>פרטי איש הקשר</h3>
            <div class="split-box-title"></div>
            <div class="row-items">
                <mat-form-field class="mat-form-field-row mat-form-field-label-15">    
                    <mat-label>שם פרטי</mat-label>
                    <input type="text" placeholder="שם פרטי" matInput formControlName="FirstName" maxlength="50" required /> 
                </mat-form-field>
                <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                    <mat-label>שם משפחה</mat-label>
                    <input type="text" placeholder="שם משפחה" matInput formControlName="LastName" maxlength="50" required /> 
                </mat-form-field>
            </div>
            <div class="row-items">
                <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                    <mat-label>כתובת</mat-label>
                    <input type="text" placeholder="כתובת" matInput formControlName="Address" maxlength="50" required /> 
                </mat-form-field>
                <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                    <mat-label>מיקוד</mat-label>
                    <input placeholder="מיקוד" matInput formControlName="Zip" maxlength="7" /> 
                </mat-form-field>
            </div>
            <div class="row-items">            
                <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                    <mat-label>טלפון</mat-label>
                    <input type="text" placeholder="טלפון" matInput formControlName="Phone" maxlength="50" required /> 
                </mat-form-field> 
                <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                    <mat-label>דואר אלקטרוני</mat-label>
                    <input type="email" placeholder="דואר אלקטרוני" matInput formControlName="Email" maxlength="50" required /> 
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="mat-field-100 mat-form-field-label-15">
                    <mat-label>הערות</mat-label>
                    <textarea matInput formControlName="Notes" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5"></textarea> 
                </mat-form-field>    
            </div>
        </div>
        <div>
            <mat-form-field class="mat-form-field-radio-group radio-row mat-field-100 mat-form-field-row mat-form-field-label-15 mat-form-field-col">
                <mat-label><b>האם ברצונך להירשם לרשימת תפוצה לקבלת מייל לגבי מכרזים שמתפרסמים?</b></mat-label>
                <input type="text" placeholder="" matInput formControlName="IsRegistered" style="display:none" required>
                <mat-radio-group formControlName="IsRegistered" name="IsRegistered" class="mat-input-element">
                    <mat-radio-button [value]="true">&nbsp; כן</mat-radio-button>
                    <mat-radio-button [value]="false">&nbsp; לא</mat-radio-button>
                </mat-radio-group>
            </mat-form-field>        
        </div>
        <div class="div-save-btn">
            <button mat-raised-button color="primary" type="submit" (click)="onSubmit()" class="fs-15" [disabled]="lockBtn">שליחה</button>
            <button mat-raised-button color="primary" type="button" (click)="onCancel()" class="fs-15">ביטול</button>
        </div>
    </form>
</div>
